

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27","height":"30"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('rect', {"width":"27","height":"2","y":"3","fill":"#CCC","rx":"1"}, []), h('path', {"stroke":"#CCC","stroke-width":"2","d":"M16 1a.997.997 0 0 1 1 1v2h-7V2a.997.997 0 0 1 1-1Z"}, []), h('g', {"transform":"translate(2 3)"}, [h('rect', {"width":"1.533","height":"17.743","x":"6.133","y":"4.629","fill":"#CCC","rx":".767"}, []), h('rect', {"width":"1.533","height":"17.743","x":"10.733","y":"4.629","fill":"#CCC","rx":".767"}, []), h('rect', {"width":"1.533","height":"17.743","x":"15.333","y":"4.629","fill":"#CCC","rx":".767"}, []), h('path', {"stroke":"#CCC","stroke-width":"2","d":"M21.94 1 20.58 24.117A1.995 1.995 0 0 1 18.584 26H4.416c-.53 0-1.013-.206-1.372-.545a1.995 1.995 0 0 1-.624-1.338L1.06 1h20.88Z"}, [])])])]);
};

        